import React, { useState } from 'react'
import { observer } from "mobx-react-lite"

import clsx from 'clsx'
import styles from './MajorMinorFilter.module.scss'

import {StyledMenu, StyledMenuItem} from '../../components/StyledMenu'
import StyledPopup from '../../components/StyledPopup'

const MajorMinorFilter = ({className, classes, model}) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  }

  const handleClose = (value) => {
    setAnchorEl(null);
    if (value) {
      model.setMode(value)
    }
  }

  const open = Boolean(anchorEl)

  const mode = model.mode

  const text = mode == 'major' ? 'Major' : (mode == 'minor' ? 'Minor' : "Major & Minor");

  return <div className={clsx(styles['root'], className)}>
    <StyledPopup value={text} open={open} handleClick={handleClick} className={clsx(classes.button, mode == 'all' ? null : styles.active)} />
    <StyledMenu anchorEl={anchorEl} open={open} onClose={() => handleClose(null)}>
      <StyledMenuItem onClick={() => handleClose("all")} selected={mode == 'all'}>Major & Minor</StyledMenuItem>
      <StyledMenuItem onClick={() => handleClose("major")} selected={mode == 'major'}>Major</StyledMenuItem>
      <StyledMenuItem onClick={() => handleClose("minor")} selected={mode == 'minor'}>Minor</StyledMenuItem>
    </StyledMenu>
  </div>
}

export default observer(MajorMinorFilter)